import { CustomVizHookStatus } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const checkLoadingStatus = ({
  status,
}: {
  status: CustomVizHookStatus;
}) => {
  return (
    status === 'loading-dropdowns' ||
    status === 'loading-viz' ||
    status === 'initialization'
  );
};
